import type { Portfolio } from '@/hooks/portfolio/usePortfolio';

type PortfolioInput = Pick<Portfolio, 'type' | 'manualInputOption'>;

/**
 * This is a temporary solution to handle the different types of portfolios until we have a more robust solution for handling different portfolio types
 **/
export const usePortfolioType = (portfolio: PortfolioInput) => {
  if (portfolio.type === 'linked') return 'linked-portfolio';
  if (
    portfolio.type === 'manual' &&
    portfolio.manualInputOption === 'transactions'
  ) {
    return 'transaction-portfolio';
  }
  // Type must be non-transactional manual
  return 'manual-portfolio';
};

export type PortfolioType = ReturnType<typeof usePortfolioType>;
